<template>
	<a-tooltip placement="top">
		<template slot="title">
			{{ $moment(item).format('LLLL') }}
		</template>

		<a-tag :color="$colors.blue">
			<fa-icon :icon="['far','clock']" />
			{{ item | moment("from", "now") }}
		</a-tag>
	</a-tooltip>
</template>

<script>
export default {
	name: 'GTableSlotDatetime',
	props: {
		item: {
			type: String,
			required: true
		}
	}
};
</script>

<style lang="scss" scoped>

</style>
